var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCloseStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #ccc;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    className: "cls-1",
    width: 20,
    height: 20,
    transform: "translate(1132 232)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248\\u7EC4_72",
    "data-name": "\\u8499\\u7248\\u7EC4 72",
    className: "cls-2",
    transform: "translate(-1132 -232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62-2",
    "data-name": "\\u77E9\\u5F62",
    className: "cls-3",
    d: "M.914,0,13.081.026A.888.888,0,0,1,14,.872a.878.878,0,0,1-.914.843L.919,1.69A.888.888,0,0,1,0,.843.878.878,0,0,1,.914,0Z",
    transform: "translate(1136.188 246.036) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62-3",
    "data-name": "\\u77E9\\u5F62",
    className: "cls-3",
    d: "M.924.025,13.081,0A.882.882,0,0,1,14,.847a.893.893,0,0,1-.924.851L.919,1.723A.882.882,0,0,1,0,.876.893.893,0,0,1,.924.025Z",
    transform: "translate(1146.226 247.421) rotate(-135)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseStart);
export default __webpack_public_path__ + "static/media/icon_close_start.4abfbce79a1d790b2cc6ae6a48c96d23.svg";
export { ForwardRef as ReactComponent };